/*
 * Date-gated variant options (early-bird tiers).
 *
 * snippets/product-variant-options.liquid renders an option as `disabled` +
 * [data-date-closed] once its custom.visible_from / custom.visible_until window
 * has passed. Liquid still picks `selected_or_first_available_variant` for the
 * price and the hidden variant id, and that may be a closed tier — so a visitor
 * would see (and be charged) the expired early-bird price.
 *
 * This selects the first still-open option and lets Dawn's own change handler
 * refresh the price, availability and buy button. It runs after <variant-selects>
 * is upgraded, and again whenever Dawn re-renders the picker (section rendering
 * replaces innerHTML, which would silently drop an inline script).
 */
(function () {
  function fixPicker(root) {
    if (!root || !root.querySelector('[data-date-closed]')) return;
    root.querySelectorAll('fieldset, .product-form__input').forEach(function (group) {
      var inputs = group.querySelectorAll('input[type="radio"], option');
      if (!inputs.length) return;
      var chosen = group.querySelector('input[type="radio"]:checked, option:checked');
      if (chosen && !chosen.disabled) return; // already on a valid option
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].disabled) continue;
        if (inputs[i].tagName === 'OPTION') {
          var sel = inputs[i].parentElement;
          sel.value = inputs[i].value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          inputs[i].checked = true;
          inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        break;
      }
    });
  }

  function fixAll() {
    document.querySelectorAll('variant-selects').forEach(fixPicker);
  }

  function start() {
    fixAll();
    // Dawn re-renders the picker via the Section Rendering API; re-apply when it does.
    var host = document.querySelector('product-info') || document.body;
    if (!window.MutationObserver || !host) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        fixAll();
      });
    }).observe(host, { childList: true, subtree: true });
  }

  function ready() {
    start();
    // Dawn's listener may attach slightly later depending on template; re-apply
    // once after full load. Do not gate on customElements.whenDefined() — the
    // 'variant-selects' name is not registered on every product template, so
    // that promise can never settle.
    window.addEventListener('load', function () { setTimeout(fixAll, 0); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
